(() => {
  if (window.MahjverseHomeScroll) return;

  const subscribers = new Set();
  const channels = new Map();
  const inputSubscribers = new Map();
  let frame = 0;

  const flush = () => {
    frame = 0;
    const snapshot = Object.freeze({
      scrollY: window.scrollY,
      viewportHeight: window.innerHeight,
      documentHeight: (document.scrollingElement || document.documentElement).scrollHeight
    });
    subscribers.forEach((subscriber) => subscriber(snapshot));
  };

  const request = () => {
    if (!frame) frame = requestAnimationFrame(flush);
  };

  const subscribe = (subscriber, options = {}) => {
    subscribers.add(subscriber);
    const unsubscribe = () => subscribers.delete(subscriber);
    options.signal?.addEventListener('abort', unsubscribe, { once: true });
    if (options.immediate !== false) request();
    return unsubscribe;
  };

  const on = (name, subscriber, options = {}) => {
    if (!channels.has(name)) channels.set(name, new Set());
    const channel = channels.get(name);
    channel.add(subscriber);
    const unsubscribe = () => {
      channel.delete(subscriber);
      if (!channel.size) channels.delete(name);
    };
    options.signal?.addEventListener('abort', unsubscribe, { once: true });
    return unsubscribe;
  };

  const emit = (name, detail) => {
    channels.get(name)?.forEach((subscriber) => subscriber(detail));
  };

  const subscribeInput = (type, subscriber, options = {}) => {
    if (!inputSubscribers.has(type)) inputSubscribers.set(type, new Set());
    const subscribersForType = inputSubscribers.get(type);
    subscribersForType.add(subscriber);
    const unsubscribe = () => {
      subscribersForType.delete(subscriber);
      if (!subscribersForType.size) inputSubscribers.delete(type);
    };
    options.signal?.addEventListener('abort', unsubscribe, { once: true });
    return unsubscribe;
  };

  const dispatchInput = (event) => {
    const subscribersForType = inputSubscribers.get(event.type);
    if (!subscribersForType) return;
    for (const subscriber of [...subscribersForType]) {
      subscriber(event);
      if (event.cancelBubble) break;
    }
  };

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('pageshow', request, { passive: true });
  window.addEventListener('wheel', dispatchInput, { capture: true, passive: false });
  window.addEventListener('touchstart', dispatchInput, { capture: true, passive: true });
  window.addEventListener('touchmove', dispatchInput, { capture: true, passive: false });
  window.addEventListener('touchend', dispatchInput, { capture: true, passive: true });
  window.MahjverseHomeScroll = Object.freeze({ emit, on, request, subscribe, subscribeInput });
})();

